export default __webpack_public_path__ + "static/media/arrow-retracted.af34620b.svg";